export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 border-t border-gray-700/50 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-lg font-bold text-white mb-3">10초게임</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              바로 플레이 가능한 브라우저 게임을 큐레이션합니다.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold text-white mb-3">법적 고지</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              본 사이트는 게임 큐레이션 디렉토리입니다. 모든 게임은 외부 플랫폼에서 제공되며, 해당 게임의 저작권은 각 개발사 및 플랫폼에 있습니다.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold text-white mb-3">연락처</h3>
            <p className="text-sm text-gray-400 mb-3">
              게임 추천 및 문의는 이메일로 보내주세요.
            </p>
            <a 
              href="mailto:haddon@mondaypawn.com"
              className="inline-flex items-center gap-2 text-sm text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              <span>haddon@mondaypawn.com</span>
            </a>
          </div>
        </div>
        
        <div className="pt-6 border-t border-gray-700/50">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © 2024 10초게임. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-sm text-gray-500">
              <span>게임 큐레이션 사이트</span>
              <span>•</span>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-cyan-400 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
